const creditsDE = {
    "view": {
        "form": {
            "title": "Credits bestellen",
            "label": {
                "quantity": "Menge"
            },
            "placeholder": {
                "quantity": "Menge auswählen"
            },
            "help_text": {
                "quantity": "Anzahl der Credits, die Sie bestellen möchten."
            },
            "button": {
                "placeOrder": "Bestellung aufgeben"
            },
            "options": {
                "quantity": {
                    "selectQuantity": "Menge auswählen",
                    "1Credit": "1 Credit",
                    "2Credits": "2 Credits",
                    "3Credits": "3 Credits",
                    "4Credits": "4 Credits",
                    "5Credits": "5 Credits",
                    "10Credits": "10 Credits",
                    "15Credits": "15 Credits",
                    "20Credits": "20 Credits",
                    "25Credits": "25 Credits",
                    "30Credits": "30 Credits",
                    "35Credits": "35 Credits",
                    "40Credits": "40 Credits",
                    "45Credits": "45 Credits",
                    "50Credits": "50 Credits",
                    "75Credits": "75 Credits",
                    "100Credits": "100 Credits"
                }
            },
            "message": {
                "quantityRequired": "Menge ist erforderlich",
                "paymentMethodRequired": "Bitte fügen Sie eine <1>Zahlungsmethode</1> hinzu, um eine Bestellung für Credits aufzugeben.",
                "paymentMethodExpired": "Sie können keine Bestellung für Credits aufgeben, da Ihre Standard-<1>Zahlungsmethode</1> abgelaufen ist. Bitte setzen Sie eine gültige Zahlungsmethode als Standard, um eine Bestellung für Credits aufzugeben."
            }
        },
        "modal": {
            "header": "Zur Kasse gehen",
            "body": {
                "message": "Sie haben {{credits}} Credits bestellt",
                "confirmationMessage": "Wenn Sie die Bestellung bestätigen möchten, gehen Sie bitte zur Kasse, andernfalls können Sie die Bestellung stornieren."
            },
            "button": {
                "cancel": "Abbrechen",
                "checkout": "Zur Kasse"
            }
        },
        "message": {
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transaktion erfolgreich :)",
            "description": "Sie haben die Credits erfolgreich gekauft, die in Kürze Ihrem Konto hinzugefügt werden!",
            "button": {
                "returnToDashboard": "Zum Dashboard zurückkehren"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transaktion abgebrochen :(",
            "description": "Die Transaktion wurde abgebrochen... Bitte versuchen Sie es später erneut!",
            "button": {
                "returnToDashboard": "Zum Dashboard zurückkehren"
            }
        }
    }
};

export default creditsDE;